import { render, staticRenderFns } from "./stockControl.vue?vue&type=template&id=ef4b2980&"
import script from "./stockControl.vue?vue&type=script&lang=js&"
export * from "./stockControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports